import React, { useState, useRef} from 'react'
import { useFlexSearch } from 'react-use-flexsearch'


export const Search = ({index, store, suggestions}) => {
	const [query, setQuery] = useState('')
	const [hideResults, setHideResults] = useState(true);

	const results = useFlexSearch(query, index, store)

	const searchInput = useRef(null);
	const onClickTag = (event, text) => {
		event.preventDefault();
		setQuery(text);
		setHideResults(false);
		searchInput.current.focus();
	};

	const style = {
		'--image': 'url(/vrouw_vergrootglas.svg)'
	}

	return (
	<div className='u-bg-blue-100 o-stretch-wrapper'>
		<div className="c-search-widget o-wrapper" style={style}>
			<div className="c-search-widget__form-block ">
				<form className="basic-form c-search-widget__form" onSubmit={(e) => e.preventDefault()}>
					<div className="form-row c-search-widget__field-column">
						<div className="form-label">
							<label className="c-search-widget__label" htmlFor="search"><h3>Waarmee kunnen we je helpen?</h3></label>
						</div>
						<div className="form-field">
							<div className="form-field-icon field-search">
								<div className="awesomplete c-search-widget__input">
									<input type="search" name="Trefwoord"
										   id="search" autoComplete="off" ref={searchInput}
										   value={query} onInput={(e) => { setQuery(e.target.value); setHideResults(false) }} onBlur={(e) => { window.setTimeout(() => setHideResults(true), 100)}}/>
									<ul className="dropdown-menu hs-slide-over" style={{'display': (query.length > 0 && hideResults !== true) ? 'block' : 'none' }}>
										{results.length ?
											results.map((result) => (
												<li className="option" key={result.id}><a href={result.url}><span className="keyword">{result.keyword}</span><span className="title">{ result.title }</span></a></li>
											)) : <li className="option"><span>Geen resultaten gevonden</span></li> }
									</ul>
								</div>
								<span className="field-icon icon-search"/>
							</div>
						</div>
					</div>
				</form>
				<div className="c-search-widget__filters">
					<p className="c-search-widget__filters-label">Bijvoorbeeld: </p>
					{ suggestions.map((suggestion, index) => (
						<div key={'suggestion-' + index} className="search-suggestion"><a href="#search" className="search-suggestion_link" onClick={(e) => onClickTag(e, suggestion.search_suggestion)}>{ suggestion.search_suggestion }</a></div>
					)) }
				</div>
			</div>
		</div>
	</div>)
};
